var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_3927_16863)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.34 110.054C126.224 109.029 126.093 107.471 125.063 106.591C124.034 105.71 122.482 105.828 121.598 106.853C120.714 107.878 120.82 109.437 121.85 110.318C122.879 111.198 124.457 111.079 125.341 110.054H125.34Z",
    fill: "url(#paint1_linear_3927_16863)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.762 116.58C121.325 115.927 121.241 114.937 120.586 114.376C119.93 113.815 118.943 113.891 118.381 114.543C117.818 115.196 117.885 116.187 118.541 116.748C119.197 117.308 120.201 117.232 120.763 116.58H120.762Z",
    fill: "url(#paint2_linear_3927_16863)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7623 22.5801C95.3248 21.927 95.241 20.9368 94.5861 20.3756C93.9303 19.8155 92.9432 19.8905 92.3807 20.5426C91.8182 21.1957 91.8851 22.187 92.541 22.7481C93.1969 23.3082 94.2009 23.2321 94.7634 22.5801H94.7623Z",
    fill: "url(#paint3_linear_3927_16863)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0008 81.2052C19.3574 80.4222 18.9976 79.4943 18.2112 79.1392C17.4247 78.7841 16.4972 79.1318 16.1406 79.9159C15.784 80.699 16.1289 81.6333 16.9153 81.9883C17.7018 82.3434 18.6442 81.9894 19.0008 81.2063V81.2052Z",
    fill: "url(#paint4_linear_3927_16863)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 65.2052C20.3574 64.4222 19.9976 63.4943 19.2112 63.1392C18.4247 62.7841 17.4972 63.1318 17.1406 63.9159C16.784 64.699 17.1289 65.6333 17.9153 65.9883C18.7018 66.3434 19.6442 65.9894 20.0008 65.2063V65.2052Z",
    fill: "url(#paint5_linear_3927_16863)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7157 73.4653C18.276 72.2341 17.7104 70.7767 16.4739 70.2188C15.2375 69.6608 13.7814 70.2071 13.221 71.4383C12.6606 72.6695 13.2019 74.1363 14.4383 74.6933C15.6748 75.2512 17.1553 74.6954 17.7157 73.4642V73.4653Z",
    fill: "url(#paint6_linear_3927_16863)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.34 26.0537C102.224 25.0286 102.093 23.4709 101.063 22.5906C100.034 21.7102 98.4822 21.8275 97.5981 22.8526C96.714 23.8777 96.8201 25.4365 97.8496 26.3179C98.8791 27.1982 100.457 27.0788 101.341 26.0537H101.34Z",
    fill: "url(#paint7_linear_3927_16863)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.206 54.0754H109.692C112.092 52.8803 113.744 50.4073 113.744 47.5401C113.744 43.508 110.483 40.2467 106.45 40.2467C102.417 40.2467 99.1454 43.508 99.1454 47.5401C99.1454 50.4073 100.803 52.8803 103.206 54.0754Z",
    fill: "url(#paint8_linear_3927_16863)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3048 110.813V55.3483C48.3048 54.6453 47.7348 54.0754 47.0317 54.0754H40.7743C40.0712 54.0754 39.5012 54.6453 39.5012 55.3483V110.813H48.3048ZM110.847 110.813V55.3483C110.847 54.6453 110.277 54.0754 109.574 54.0754H103.316C102.613 54.0754 102.043 54.6453 102.043 55.3483V110.813H110.847Z",
    fill: "url(#paint9_linear_3927_16863)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3048 110.813V111.113H48.6048V110.813H48.3048ZM39.5012 110.813H39.2012V111.113H39.5012V110.813ZM110.847 110.813V111.113H111.147V110.813H110.847ZM102.043 110.813H101.743V111.113H102.043V110.813ZM48.0048 55.3483V110.813H48.6048V55.3483H48.0048ZM47.0317 54.3754C47.5692 54.3754 48.0048 54.811 48.0048 55.3483H48.6048C48.6048 54.4795 47.9004 53.7754 47.0317 53.7754V54.3754ZM40.7743 54.3754H47.0317V53.7754H40.7743V54.3754ZM39.8012 55.3483C39.8012 54.811 40.2368 54.3754 40.7743 54.3754V53.7754C39.9055 53.7754 39.2012 54.4795 39.2012 55.3483H39.8012ZM39.8012 110.813V55.3483H39.2012V110.813H39.8012ZM48.3048 110.513H39.5012V111.113H48.3048V110.513ZM110.547 55.3483V110.813H111.147V55.3483H110.547ZM109.574 54.3754C110.111 54.3754 110.547 54.811 110.547 55.3483H111.147C111.147 54.4795 110.442 53.7754 109.574 53.7754V54.3754ZM103.316 54.3754H109.574V53.7754H103.316V54.3754ZM102.343 55.3483C102.343 54.811 102.779 54.3754 103.316 54.3754V53.7754C102.447 53.7754 101.743 54.4795 101.743 55.3483H102.343ZM102.343 110.813V55.3483H101.743V110.813H102.343ZM110.847 110.513H102.043V111.113H110.847V110.513Z",
    fill: "#5A7FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.5 112.792V115.82C115.5 116.606 114.862 117.241 114.079 117.241H98.8091C98.0232 117.241 97.3879 116.603 97.3879 115.82V112.792C97.3879 111.7 98.2743 110.814 99.3666 110.814H113.521C114.613 110.814 115.5 111.7 115.5 112.792ZM52.9577 112.792V115.82C52.9577 116.606 52.3199 117.241 51.5365 117.241H36.267C35.481 117.241 34.8457 116.603 34.8457 115.82V112.792C34.8457 111.7 35.7321 110.814 36.8244 110.814H50.979C52.0713 110.814 52.9577 111.7 52.9577 112.792Z",
    fill: "url(#paint10_linear_3927_16863)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.8 115.82V112.792H115.2V115.82H115.8ZM114.079 117.541C115.027 117.541 115.8 116.772 115.8 115.82H115.2C115.2 116.44 114.697 116.941 114.079 116.941V117.541ZM98.8091 117.541H114.079V116.941H98.8091V117.541ZM97.0879 115.82C97.0879 116.768 97.8572 117.541 98.8091 117.541V116.941C98.1892 116.941 97.6879 116.438 97.6879 115.82H97.0879ZM97.0879 112.792V115.82H97.6879V112.792H97.0879ZM99.3666 110.514C98.1087 110.514 97.0879 111.534 97.0879 112.792H97.6879C97.6879 111.866 98.44 111.114 99.3666 111.114V110.514ZM113.521 110.514H99.3666V111.114H113.521V110.514ZM115.8 112.792C115.8 111.534 114.779 110.514 113.521 110.514V111.114C114.448 111.114 115.2 111.866 115.2 112.792H115.8ZM53.2577 115.82V112.792H52.6577V115.82H53.2577ZM51.5365 117.541C52.4852 117.541 53.2577 116.772 53.2577 115.82H52.6577C52.6577 116.44 52.1546 116.941 51.5365 116.941V117.541ZM36.267 117.541H51.5365V116.941H36.267V117.541ZM34.5457 115.82C34.5457 116.768 35.3151 117.541 36.267 117.541V116.941C35.647 116.941 35.1457 116.438 35.1457 115.82H34.5457ZM34.5457 112.792V115.82H35.1457V112.792H34.5457ZM36.8244 110.514C35.5665 110.514 34.5457 111.534 34.5457 112.792H35.1457C35.1457 111.866 35.8978 111.114 36.8244 111.114V110.514ZM50.979 110.514H36.8244V111.114H50.979V110.514ZM53.2577 112.792C53.2577 111.534 52.237 110.514 50.979 110.514V111.114C51.9057 111.114 52.6577 111.866 52.6577 112.792H53.2577Z",
    fill: "#5A7FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.279 61.0073V73.7965C119.279 75.451 117.94 76.7967 116.286 76.7967H31.948C30.3158 76.7666 29.0001 75.4359 29.0001 73.7965V61.0073C29.0001 59.3452 30.346 58.007 32.0007 58.007H116.286C116.376 58.007 116.466 58.0146 116.549 58.0221C118.083 58.1501 119.279 59.4356 119.279 61.0073Z",
    fill: "url(#paint11_linear_3927_16863)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.281 86.7188V93.2942C119.281 94.9487 117.943 96.2944 116.288 96.2944H32.0032C31.2625 96.2944 30.582 96.0308 30.0522 95.5839C29.4094 95.024 29.0001 94.208 29.0001 93.2942V86.7188C29.0001 85.0643 30.346 83.7186 32.0007 83.7186H116.286C116.657 83.7186 117.011 83.7863 117.338 83.9144C118.473 84.3387 119.281 85.4333 119.281 86.7188Z",
    fill: "url(#paint12_linear_3927_16863)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6639 54.0754H47.1498C49.5503 52.8803 51.2026 50.4073 51.2026 47.5401C51.2026 43.508 47.9408 40.2467 43.9081 40.2467C39.8754 40.2467 36.6035 43.508 36.6035 47.5401C36.6035 50.4073 38.2608 52.8803 40.6639 54.0754Z",
    fill: "url(#paint13_linear_3927_16863)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.569 83.7161L55.0416 96.2969H47.5412L56.0686 83.7161H63.569ZM45.5978 83.7161L37.0704 96.2944H32.0057C31.2649 96.2944 30.5845 96.0308 30.0546 95.5839L38.0999 83.7161H45.5978ZM73.0059 96.2969L81.5333 83.7161H74.0404L65.513 96.2969H73.0059ZM99.5043 83.7161L90.9769 96.2969H83.484L92.0114 83.7161H99.5043ZM108.948 96.2969L117.34 83.9144C117.014 83.7864 116.66 83.7186 116.288 83.7186H109.975L101.448 96.2969H108.948Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6772 58.0095L44.6789 58.007L44.6814 58.0095H44.6772ZM44.6772 58.0095L31.948 76.7992C30.3159 76.7691 29.0001 75.4385 29.0001 73.799V70.0958L37.1885 58.0095H44.6772ZM49.9169 76.7992L62.6502 58.007H55.1498L42.4165 76.7992H49.9169ZM80.6215 58.007L67.8882 76.7992H60.3877L73.1211 58.007H80.6215ZM85.8521 76.7992L98.5855 58.007H91.0926L78.3592 76.7992H85.8521ZM116.547 58.0221L103.823 76.7992H96.3305L109.061 58.007H116.281C116.371 58.007 116.461 58.0146 116.544 58.0221H116.547ZM119.276 73.799V69.4456V69.4431L114.294 76.7993H116.283C117.938 76.7993 119.276 75.4536 119.276 73.799Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3008 48.8306L84.403 60.7763C83.7025 61.9889 82.4093 62.7371 81.0082 62.7371H67.2076C65.8065 62.7371 64.5133 61.9889 63.8127 60.7763L56.915 48.8306C56.2144 47.618 56.2144 46.1241 56.915 44.9115L63.8127 32.9608C64.5133 31.7482 65.8065 31 67.2076 31H81.0082C82.4093 31 83.705 31.7482 84.403 32.9608L91.3008 44.9115C92.0014 46.1241 92.0014 47.618 91.3008 48.8306Z",
    fill: "url(#paint14_linear_3927_16863)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3355 47.5829L81.8395 58.8356C81.5884 59.275 81.1113 59.5486 80.6066 59.5486H67.6121C67.1024 59.5486 66.6303 59.275 66.3742 58.8356L59.8832 47.5829C59.6271 47.1435 59.6271 46.6012 59.8832 46.1568L66.3792 34.9091C66.6303 34.4672 67.1024 34.1961 67.6121 34.1961H80.6066C81.1113 34.1961 81.5834 34.4647 81.8395 34.9091L88.3355 46.1618C88.5866 46.6012 88.5866 47.1435 88.3355 47.5829Z",
    fill: "url(#paint15_linear_3927_16863)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9976 49.3152C72.5362 49.3101 71.5218 48.562 70.9894 47.2841C70.442 45.9685 70.442 43.8595 70.9944 42.554C71.5268 41.2936 72.5387 40.5605 73.9976 40.5605C76.3831 40.5605 77.4176 42.5038 77.4101 44.9115C77.4101 47.3418 76.3856 49.3152 73.9976 49.3152ZM73.9976 47.8339C75.2858 47.8339 75.5896 46.2045 75.5871 44.9115C75.5871 43.6311 75.2808 42.0268 73.9976 42.0268C72.7145 42.0268 72.4081 43.6311 72.4031 44.9115C72.4031 46.202 72.707 47.8339 73.9976 47.8339ZM68.4406 46.212V40.9899C68.4406 40.8191 68.3025 40.6785 68.1293 40.6785C67.749 40.6785 67.4449 40.6766 67.2008 40.6751C66.2212 40.669 66.2064 40.6689 66.1079 40.8216L62.723 46.1593C62.6904 46.2095 62.6753 46.2672 62.6753 46.325V47.3292C62.6753 47.5 62.8134 47.6406 62.9867 47.6406H66.7306V48.8181C66.7306 48.9888 66.8687 49.1294 67.042 49.1294H68.1318C68.3025 49.1294 68.4432 48.9913 68.4432 48.8181V47.6406H69.1814C69.3521 47.6406 69.4928 47.5025 69.4928 47.3292V46.5208C69.4928 46.3501 69.3546 46.2095 69.1814 46.2095H68.4432L68.4406 46.212ZM64.4732 46.212V46.1442L66.698 42.6243H66.7658V46.212H64.4732ZM84.3204 40.9899V46.2095H85.0586C85.2318 46.2095 85.3699 46.3501 85.3699 46.5208V47.3292C85.3699 47.5025 85.2293 47.6406 85.0586 47.6406H84.3204V48.8181C84.3204 48.9913 84.1797 49.1294 84.009 49.1294H82.9192C82.7459 49.1294 82.6078 48.9888 82.6078 48.8181V47.6406H78.8639C78.6907 47.6406 78.5525 47.5 78.5525 47.3292V46.325C78.5525 46.3147 78.5512 46.3076 78.5505 46.3004C78.5422 46.2171 78.6234 46.125 81.9876 40.8216C82.0861 40.6689 82.1009 40.669 83.0805 40.6751C83.3246 40.6766 83.6287 40.6785 84.009 40.6785C84.1823 40.6785 84.3204 40.8191 84.3204 40.9899ZM80.353 46.212H82.6455V42.6243H82.5777L80.353 46.1442V46.212Z",
    fill: "#5A7FFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3528 52.9004H68.0161C67.7676 52.9004 67.5692 52.6996 67.5692 52.4535C67.5692 52.2075 67.7701 52.0066 68.0161 52.0066H80.3528C80.6014 52.0066 80.7997 52.2075 80.7997 52.4535C80.7997 52.6996 80.5989 52.9004 80.3528 52.9004Z",
    fill: "#C3CEF5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.872 55.4889H70.4971C70.2485 55.4889 70.0501 55.288 70.0501 55.042C70.0501 54.7959 70.251 54.5951 70.4971 54.5951H77.872C78.1205 54.5951 78.3189 54.7959 78.3189 55.042C78.3189 55.288 78.118 55.4889 77.872 55.4889Z",
    fill: "#C3CEF5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.44 51.7304C108.75 51.7304 110.623 49.8575 110.623 47.5477C110.623 45.2379 108.74 43.375 106.44 43.375C104.14 43.375 102.267 45.2379 102.267 47.5477C102.267 49.8575 104.13 51.7304 106.44 51.7304ZM43.8978 51.7304C46.2079 51.7304 48.0811 49.8575 48.0811 47.5477C48.0811 45.2379 46.1979 43.375 43.8978 43.375C41.5977 43.375 39.7245 45.2379 39.7245 47.5477C39.7245 49.8575 41.5877 51.7304 43.8978 51.7304Z",
    fill: "url(#paint16_linear_3927_16863)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_16863",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3927_16863",
    x1: 123.464,
    y1: 106,
    x2: 123.464,
    y2: 110.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3927_16863",
    x1: 119.568,
    y1: 114,
    x2: 119.568,
    y2: 117.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3927_16863",
    x1: 93.568,
    y1: 20,
    x2: 93.568,
    y2: 23.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3927_16863",
    x1: 17.5694,
    y1: 79,
    x2: 17.5694,
    y2: 82.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3927_16863",
    x1: 18.5694,
    y1: 63,
    x2: 18.5694,
    y2: 66.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3927_16863",
    x1: 15.4662,
    y1: 70,
    x2: 15.4662,
    y2: 74.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3927_16863",
    x1: 99.4638,
    y1: 22,
    x2: 99.4638,
    y2: 26.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3927_16863",
    x1: 106.445,
    y1: 40.2467,
    x2: 106.445,
    y2: 54.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92A8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3927_16863",
    x1: 53.7199,
    y1: 53.5703,
    x2: 49.4208,
    y2: 110.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DEF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3927_16863",
    x1: 69.3041,
    y1: 110.533,
    x2: 69.3041,
    y2: 116.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3927_16863",
    x1: 74.1934,
    y1: 58.1577,
    x2: 74.103,
    y2: 73.7739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3927_16863",
    x1: 73.8393,
    y1: 83.8165,
    x2: 74.2384,
    y2: 91.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3927_16863",
    x1: 43.9031,
    y1: 40.2467,
    x2: 43.9031,
    y2: 54.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92A8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3927_16863",
    x1: 92.5136,
    y1: 48.4264,
    x2: 45.4045,
    y2: 44.4408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3927_16863",
    x1: 64.2269,
    y1: 36.8711,
    x2: 79.4917,
    y2: 57.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3927_16863",
    x1: 39.7245,
    y1: 47.5527,
    x2: 48.0812,
    y2: 47.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.5f64e8a0c8560176020c3f273ac7fc10.svg";
export { ForwardRef as ReactComponent };